import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const createWriting = async (writingData) => {
  const response = await apiClient.post(ENDPOINTS.WRITING.BASE, writingData);
  return response.data;
};

export const getAllWritings = async () => {
  const response = await apiClient.get(ENDPOINTS.WRITING.BASE);
  return response.data;
};

export const getWritingById = async (id) => {
  const response = await apiClient.get(`${ENDPOINTS.WRITING.BASE}/${id}`);
  return response.data;
};

export const updateWriting = async (id, writingData) => {
  const response = await apiClient.put(`${ENDPOINTS.WRITING.BASE}/${id}`, writingData);
  return response.data;
};

export const deleteWriting = async (id) => {
  const response = await apiClient.delete(`${ENDPOINTS.WRITING.BASE}/${id}`);
  return response.data;
};

export const getWritingQuestions = async (writingId) => {
  return await getWritingById(writingId);
};

export const getWritingQuestion = async (writingId, questionId) => {
  const writingData = await getWritingById(writingId);
  return writingData.Questions.find(q => q._id === questionId);
};

export const createWritingQuestion = async (writingId, questionData) => {
  const response = await apiClient.post(`${ENDPOINTS.WRITING.BASE}/${writingId}/questions`, questionData);
  return response.data;
};

export const updateWritingQuestion = async (writingId, questionId, questionData) => {
  const response = await apiClient.put(`${ENDPOINTS.WRITING.BASE}/${writingId}/questions/${questionId}`, questionData);
  return response.data;
};

export const deleteWritingQuestion = async (writingId, questionId) => {
  const response = await apiClient.delete(`${ENDPOINTS.WRITING.BASE}/${writingId}/questions/${questionId}`);
  return response.data;
};
